import {Component, Input, OnInit} from '@angular/core';
import {ContactFieldPreset} from '../../../services/contact-field-preset';
import {Order} from '../../../services/order';
import {CONTACT_TYPES_IDS} from '../../../../config/constants-10-4';
import {Contact} from '../../../services/contact';

@Component({
    selector: 'app-client-contact-meta',
    templateUrl: './client-contact-meta.component.html',
    styleUrls: ['./client-contact-meta.component.scss']
})
export class ClientContactMetaComponent implements OnInit {

    @Input() order: Order;

    invoiceContact: Contact;
    metaContact: Contact;

    constructor() {
    }

    ngOnInit(): void {
        this.invoiceContact = this.order.getContactWithTypeId(CONTACT_TYPES_IDS.INVOICE_ADDRESS);
        this.metaContact = this.order.getContactWithTypeId(CONTACT_TYPES_IDS.INVOICE_META);
    }

}
